// extracted by mini-css-extract-plugin
export var icon = "_q3-0";